import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import useUBStore from "@/stores/UBStore";

export default function useUbidFromRoute() {
    const { ubid, setUbid } = useUBStore();
    const searchParams = useSearchParams();
    const ubQueryParam = searchParams.get("ubid") || searchParams.get("ub");

    useEffect(() => {
        if (ubQueryParam !== null && ubid === "" && ubid !== ubQueryParam) {
            setUbid(ubQueryParam);
        }
        useUBStore.persist.rehydrate();
    }, [ubid, setUbid, ubQueryParam]);

    return { ubid, setUbid };
}
